import calculateCappedModuleDuration from './calculateCappedModuleDuration';
export default function calculateCappedSessionDuration(modules) {
    const durations = modules.map(m => calculateCappedModuleDuration(m.timeStarted, m.timeFinished));
    return durations.reduce((previousValue, currentValue) => previousValue + currentValue, 0);
}
